import { render, staticRenderFns } from "./ExchangeGoodCard.vue?vue&type=template&id=9b271c6c&scoped=true"
import script from "./ExchangeGoodCard.vue?vue&type=script&lang=js"
export * from "./ExchangeGoodCard.vue?vue&type=script&lang=js"
import style0 from "./ExchangeGoodCard.vue?vue&type=style&index=0&id=9b271c6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b271c6c",
  null
  
)

export default component.exports